function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
import Poll from './poll';
import Keyword from './mixins/_keyword';
import Responds from './mixins/_responds';
import URI from 'urijs';
import WordCloudStats from './word_cloud_stats';

var FreeTextPoll = /*#__PURE__*/function (_Poll) {
  _inheritsLoose(FreeTextPoll, _Poll);

  function FreeTextPoll() {
    return _Poll.apply(this, arguments) || this;
  }

  var _proto = FreeTextPoll.prototype;

  _proto.initialize = function initialize() {
    _Poll.prototype.initialize.apply(this, arguments);

    this.wordcloudStats = new WordCloudStats({
      poll: this
    });
    this.include(Keyword);
    this.include(Responds);
    this.initKeyword();
    /*
     * Once the server has confirmed a new keyword, we need to save it
     * locally so that we don't incorrectly say that the keyword is taken
     * next time validations are run.
     */

    this.listenTo(this, 'sync', this.initKeyword);
  };

  _proto.toggleAutocensor = function toggleAutocensor(val, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.toggle('autocensor', opts, val);
  };

  _proto.supportsModeration = function supportsModeration() {
    return true;
  };

  _proto.toggleModeration = function toggleModeration(_active, _success) {
    return this.toggle('moderation_enabled');
  };

  _proto.isModerationEnabled = function isModerationEnabled() {
    return this.get('moderation_enabled') === true;
  };

  _proto.parse = function parse(json, options) {
    if (options === void 0) {
      options = {};
    }

    json = _Poll.prototype.parse.apply(this, arguments);

    if (options.resetKeyword) {
      this.resetKeyword(json.keyword);
    } // All results are included in the instance API and parsed into the results
    // collection. Json key is removed so we maintain a single source of truth.
    // Use `set` to trigger events for all actions: add, update, remove.


    if (json.results) {
      this.results.set(json.results);
      delete json.results;
    }

    return json;
  };

  _proto.fetch = function fetch() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var isFreeTextPoll = this.defaultType === 'free_text_poll';

    if (isFreeTextPoll) {
      return Backbone.$.Deferred(function (dfd) {
        var _Poll$prototype$fetch;

        Backbone.$.when((_Poll$prototype$fetch = _Poll.prototype.fetch).call.apply(_Poll$prototype$fetch, [_this].concat(args)), _this.wordcloudStats.fetch()).then(function (res) {
          return dfd.resolve(res);
        })["catch"](dfd.reject);
        return dfd;
      });
    } else {
      var _Poll$prototype$fetch2;

      return (_Poll$prototype$fetch2 = _Poll.prototype.fetch).call.apply(_Poll$prototype$fetch2, [this].concat(args));
    }
  }
  /**
   * Parse Firehose response into the model.
   * @param {object} data Firehose response data.
   * @return {object} Returns potentially mutated data.
   */
  ;

  _proto.processLiveResponse = function processLiveResponse(data) {
    if (data === void 0) {
      data = {};
    }

    if (data.result) {
      if (data.result.deleted_at) {
        this.results.remove(data.result);
      } else {
        this.results.add(data.result, {
          merge: true
        });
      } // Result object is only contained within Firehose messages. Remove this
      // from the dataset to prevent it from getting set on the model.


      delete data.result;
    } // Firehose will update the results count, but omit the results list key.
    // When results count is set to 0, we create a results key to an empty array
    // so the internal collection will be cleared via `parse()`.


    if (data.results_count === 0) {
      data.results = [];
    } // Process and parse data into the model. This must happen after any
    // mutations to the data response object.


    data = _Poll.prototype.processLiveResponse.call(this, data);
    this.flashOptions().processLiveResponse(data);
    return data;
  };

  _proto.hasCustomGlobalKeyword = function hasCustomGlobalKeyword() {
    return !this.get('simple_keywords') && !this.isAutoKeyword();
  };

  _proto.responseUrl = function responseUrl() {
    var permalink = this.get('permalink');
    return URI('/').segment(this.type() + 's').segment(permalink).segment('results.json').toString();
  };

  _createClass(FreeTextPoll, [{
    key: "defaultType",
    get: function get() {
      return 'free_text_poll';
    }
  }, {
    key: "modelProperties",
    get: function get() {
      return _Poll.prototype.modelProperties.concat(['moderation_enabled', 'autocensor', 'keyword', 'emoji_filter', 'instruction_image_url', 'instruction_image_alt']);
    }
  }]);

  return FreeTextPoll;
}(Poll);

export { FreeTextPoll as default };